import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../services/auth/auth.service';
import { HttpService } from '../services/http/http.service';
@Component({
  selector: 'app-landing',
  templateUrl: './landing.component.html',
  styleUrls: ['./landing.component.scss']
})
export class LandingComponent implements OnInit {
  constructor(private router: Router, private auth: AuthService, private api:HttpService) { }
  roles: any;
  breadLinks:any={
    'firstLink':{
      'name':'Home',
      'link':'/'
    },
    'secondLink':{
      'name':'',
      'link':''
    },
    'thirdLink':{
      'name':'Profili',
      'link':''
    }
  }
  ngOnInit(): void {
    this.auth.authLogin().subscribe({
      next: (response:any) => {
       
        sessionStorage.setItem('CF',response.result.codiceFiscale);
        sessionStorage.setItem('userInfo',JSON.stringify(response.result));
        let cf = sessionStorage.getItem('CF') ?? '';
        this.auth.userRoles(cf).subscribe({
          next: (response: any) => {
            this.roles = response.result;
          }
        })
     }
    })

  }

  toHome(roleId:any): void {
    
    this.api.setRuoloAttivo(roleId).subscribe({
      next: () => {
        this.router.navigate(['secured/home']);
      }
    })
  }
}
